import Search from '../../../common/search';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import Badges from './Badges';

function Filter({ screen, onSearch }) {
  const searchChatText = useGlotaT('spa.chat.searchChat');
  
  return (
    <div className="filtersContainer">
      <div className="searchGroupFilters">
        <Search
          placeholder={searchChatText}
          whoSendAction="chat"
          screen={screen}
          onSearch={onSearch}
        />
      </div>
      <Badges />
    </div>
  );
}

export default Filter;
